<template>
	<div v-editable="blok" class="flex flex-1">
		<div v-if="blok.icon.filename" class="h-6 w-6 mr-3">
			<NuxtImg
				:src="blok.icon.filename"
				loading="lazy"
				provider="storyblok"
				:alt="blok.title"
				sizes="30vw md:40vw"
				width="24"
				height="24"
			/>
		</div>
		<div class="flex-1">
			<div class="text-lg leading-6 font-medium mb-2 text-gray-900">
				{{ blok.title }}
			</div>
			<div class="text-gray-super-dark">
				{{ blok.description }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { BlokFeature } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokFeature;
}

const { blok } = defineProps<Props>();
</script>
